import React from 'react';

import './ccpa-notice.scss';

const CCPANotice = () => (
  <>
    <table id="agreement">
      <tbody>
        <tr>
          <td colspan="5">
            <p style={{ textAlign: 'center' }}>
              <strong>Personal Information Collection, Disclosure, and Sale</strong>
            </p>

            <p>&nbsp;</p>

            <p>
              For the purposes of this notice, <strong>Personal Information</strong> means
              information that identifies, relates to, describes, is reasonably capable of being
              associated with, or could reasonably be linked, directly or indirectly, with a
              particular consumer or household, or as otherwise defined by the California Consumer
              Privacy Act of 2018 (California Civil Code §§ 1798.100 to 1798.199) and its
              implementing regulations, as amended or superseded from time to time (“
              <strong>CCPA</strong>”).
            </p>

            <p>&nbsp;</p>

            <p>Personal Information does not include information that is:</p>

            <ul>
              <li style={{ marginLeft: '40px' }}>
                <p>Lawfully made available from government records.</p>
              </li>
              <li style={{ marginLeft: '40px' }}>
                <p>Deidentified or aggregated.</p>
              </li>
              <li style={{ marginLeft: '40px' }}>
                <p>Otherwise excluded from the scope of the CCPA.</p>
              </li>
            </ul>

            <p>&nbsp;</p>

            <p>
              The chart below provides the categories of Personal Information (as defined by the
              CCPA) we have collected, disclosed for a business purpose, sold, or used for business
              or commercial purposes in the preceding twelve months since this notice was last
              updated, as well as the categories of sources from which that information was
              collected, and the categories of third parties with whom we shared Personal
              Information. The examples of Personal Information provided for each category reflect
              each category’s statutory definition and may not reflect all of the specific types of
              Personal Information associated with each category.
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p>
              <strong>Category</strong>
            </p>
          </td>
          <td>
            <p>
              <strong>We Collect</strong>
            </p>
          </td>
          <td>
            <p>
              <strong>We Disclose</strong>
            </p>
          </td>
          <td>
            <p>
              <strong>We Sell&nbsp;</strong>
            </p>
          </td>
          <td>
            <p>
              <strong>Categories of Third Parties with Whom We Share Personal Information</strong>
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p>
              <strong>A. Identifiers </strong>
              <br />
              &nbsp;
            </p>

            <p>
              <em>Examples: </em>Name, alias, postal address, unique personal identifier, online
              identifier, internet protocol address, email address, account name, social security
              number, driver’s license number, passport number, or other similar identifiers.&nbsp;
            </p>
          </td>
          <td>
            <p>Yes</p>
          </td>
          <td>
            <p>Yes</p>
          </td>
          <td>
            <p>No</p>
          </td>
          <td>
            <p>
              Advertising Providers, Analytics Providers, Affiliates, Vendors, Integrated Third
              Parties, Third Parties with Consent.&nbsp;
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p>
              <strong>
                B. Categories of Personal Information in Cal. Civ. Code Section 1798.80(e)
              </strong>
            </p>

            <p>&nbsp;</p>

            <p>
              <em>Examples: </em>Name, signature, social security number, physical characteristics
              or description, address, telephone number, passport number, driver’s license or state
              identification card number, insurance policy number, education, employment, employment
              history, bank account number, credit card number, debit card number, or any other
              financial information, medical information, or health insurance information.
            </p>
          </td>
          <td>
            <p>Yes</p>
          </td>
          <td>
            <p>Yes</p>
          </td>
          <td>
            <p>No</p>
          </td>
          <td>
            <p>
              Advertising Providers, Analytics Providers, Affiliates, Vendors, Integrated Third
              Parties, Third Parties with Consent.&nbsp;
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p>
              <strong>
                C. Characteristics of Protected Classifications under California or Federal
                Law&nbsp;
              </strong>
            </p>

            <p>&nbsp;</p>

            <p>
              <em>Examples: </em>Race or color, ancestry or national origin, religion or creed, age
              (over 40), mental or physical disability, sex (including gender and pregnancy,
              childbirth, breastfeeding or related medical conditions), sexual orientation, gender
              identity or expression, medical condition, genetic information, marital status,
              military and veteran status.
            </p>
          </td>
          <td>
            <p>
              Yes, we receive information regarding whether you are eligible for a medical baseline
              utility rate and your marital status.
            </p>
          </td>
          <td>
            <p>Yes</p>
          </td>
          <td>
            <p>No</p>
          </td>
          <td>
            <p>
              Analytics Providers, Affiliates, Integrated Third Parties, Third Parties with Consent.
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p>
              <strong>D. Commercial Information</strong>
            </p>

            <p>&nbsp;</p>

            <p>
              <em>Examples: </em>Records of personal property, products or services purchased,
              obtained, or considered, or other purchasing or consuming histories or
              tendencies.&nbsp;
            </p>
          </td>
          <td>
            <p>Yes</p>
          </td>
          <td>
            <p>Yes</p>
          </td>
          <td>
            <p>No</p>
          </td>
          <td>
            <p>
              Advertising Providers, Analytics Providers, Affiliates, Vendors, Integrated Third
              Parties, Third Parties with Consent.&nbsp;
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p>
              <strong>E. Biometric Information&nbsp;</strong>
            </p>

            <p>&nbsp;</p>

            <p>
              <em>Examples: </em>Physiological, biological, or behavioral characteristics, including
              DNA, that can be used, singly or in combination with each other or with other
              identifying data, to establish individual identity, such as imagery of the iris,
              retina, fingerprint, face, hand, palm, vein patterns, and voice recordings, from which
              an identifier template, such as a faceprint, a minutiae template, or a voiceprint, can
              be extracted, and keystroke patterns or rhythms, gait patterns or rhythms, and sleep,
              health, or exercise data that contain identifying information.&nbsp;
            </p>
          </td>
          <td>
            <p>No</p>
          </td>
          <td>
            <p>N/A</p>
          </td>
          <td>
            <p>N/A</p>
          </td>
          <td>
            <p>N/A</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>
              <strong>F. Internet or Other Electronic Network Activity Information&nbsp;</strong>
            </p>

            <p>&nbsp;</p>

            <p>
              <em>Examples: </em>Browsing history, search history, and information regarding a
              consumer’s interaction with an internet website, application or advertisement.&nbsp;
            </p>
          </td>
          <td>
            <p>Yes</p>
          </td>
          <td>
            <p>Yes</p>
          </td>
          <td>
            <p>No</p>
          </td>
          <td>
            <p>
              Advertising Providers, Analytics Providers, Affiliates, Vendors, Integrated Third
              Parties, Third Parties with Consent.&nbsp;
            </p>

            <p>&nbsp;</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>
              <strong>G. Geolocation Data</strong>
            </p>

            <p>&nbsp;</p>

            <p>
              <em>Example: </em>Precise physical location.&nbsp;
            </p>
          </td>
          <td>
            <p>Yes</p>
          </td>
          <td>
            <p>Yes</p>
          </td>
          <td>
            <p>No</p>
          </td>
          <td>
            <p>Affiliates, Vendors, Integrated Third Parties, Third Parties with Consent.&nbsp;</p>

            <p>&nbsp;</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>
              <strong>H. Sensory Information</strong>
            </p>

            <p>&nbsp;</p>

            <p>
              <em>Examples: </em>Audio, electronic, visual, thermal, olfactory, or similar
              information.
            </p>
          </td>
          <td>
            <p>Yes</p>
          </td>
          <td>
            <p>Yes</p>
          </td>
          <td>
            <p>No</p>
          </td>
          <td>
            <p>Affiliates, Vendors, Integrated Third Parties, Third Parties with Consent.&nbsp;</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>
              <strong>I. Professional or employment-related information</strong>
            </p>

            <p>&nbsp;</p>

            <p>
              <em>Examples: </em>Job application or resume information, past and current job
              history, and job performance information.
            </p>
          </td>
          <td>
            <p>No</p>
          </td>
          <td>
            <p>N/A</p>
          </td>
          <td>
            <p>N/A</p>
          </td>
          <td>
            <p>N/A</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>
              <strong>
                J. Non-Public Education Information (as defined in 20 U.S.C. 1232g; 34 C.F.R. Part
                99)
              </strong>
            </p>

            <p>&nbsp;</p>

            <p>
              <em>Examples: </em>Records that are directly related to a student maintained by an
              educational agency or institution or by a party acting for the agency or institution.{' '}
              <strong>&nbsp;</strong>
            </p>
          </td>
          <td>
            <p>No</p>
          </td>
          <td>
            <p>N/A</p>
          </td>
          <td>
            <p>N/A</p>
          </td>
          <td>
            <p>N/A</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>
              <strong>K. Inferences Drawn from Personal Information</strong>
            </p>

            <p>&nbsp;</p>

            <p>
              <em>Examples: </em>Consumer profiles reflecting a consumer’s preferences,
              characteristics, psychological trends, predispositions, behavior, attitudes,
              intelligence, abilities, and aptitudes.&nbsp;
            </p>
          </td>
          <td>
            <p>Yes</p>
          </td>
          <td>
            <p>Yes</p>
          </td>
          <td>
            <p>No</p>
          </td>
          <td>
            <p>
              Advertising Providers, Analytics Providers, Affiliates, Vendors, Integrated Third
              Parties, Third Parties with Consent.&nbsp;
            </p>

            <p>&nbsp;</p>
          </td>
        </tr>
      </tbody>
    </table>
  </>
);

export default CCPANotice;
